






































import { Prop, Component } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';

@Component({})
export default class SwSpinningProgress extends SwExtendedVue {
  @Prop({ type: String, default: '16px' })
  size: string;

  @Prop({ type: String, default: '#A9A9A9' })
  color: string;

  pieces: number = 12;

  get timeInterval(): number {
    return 0.9 / this.pieces;
  }

  private rotate(index: number) {
    return `rotate(${(index - 1) * 30}deg)`;
  }

  private animationDelay(index: number) {
    return `${-(this.pieces - (index - 1)) * 0.075}s`;
  }

}
